import { Button } from '@tryhackme/thm-ui-components';
import type { StepData } from '../reprofiling-modal/reprofiling-modal.types';
import { StyledBottomRow, StyledButtonRow, StyledProgressBar } from './footer.styles';
import type { ReprofilingFooterProps } from './footer.types';
const CtaButton = (currentStep: number, stepsData: StepData[], onNext: () => void) => {
  return <Button onClick={onNext} data-sentry-element="Button" data-sentry-component="CtaButton" data-sentry-source-file="footer.tsx">{stepsData[currentStep]?.cta}</Button>;
};
export const ReprofilingFooter = ({
  amountOfSteps,
  currentStep,
  onNext,
  onBack,
  stepsData
}: ReprofilingFooterProps) => {
  return <StyledBottomRow data-sentry-element="StyledBottomRow" data-sentry-component="ReprofilingFooter" data-sentry-source-file="footer.tsx">
      <StyledProgressBar amountOfSteps={amountOfSteps} currentStep={currentStep + 1} data-sentry-element="StyledProgressBar" data-sentry-source-file="footer.tsx" />
      <StyledButtonRow data-sentry-element="StyledButtonRow" data-sentry-source-file="footer.tsx">
        {currentStep > 0 && <Button color="secondary" variant="outlined" onClick={onBack}>
            Back
          </Button>}
        {CtaButton(currentStep, stepsData, onNext)}
      </StyledButtonRow>
    </StyledBottomRow>;
};